<template>
  <div class="change-stat">
    <h3 class="change-stat__heading text--center">{{heading}}</h3>

    <div class="change-stat__value">
      <div class="font-condensed">{{value}}</div>

      <div class="change-stat__direction--up" v-if="direction == 'up'"></div>
      <div class="change-stat__direction--down" v-if="direction == 'down'"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'change-stat',

  props: [
    'heading',
    'value',
    'direction'
  ],

  data: function () {
    return {

    }
  },

  mounted:function() {

  },

  beforeDestroy: function() {

  },

  methods: {

  },

  computed:{


  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../../../less/base/project/_variables";
  @import "../../../less/base/project/_colors";

  @padding: 1.6vh;

  h3 {
    font-size: 1.8rem;
  }

  .change-stat {
    width: ~"calc(100% + 4rem)";
    height: ~"calc(50% + 2rem)";
    position: relative;
    margin: -2rem -2rem;
    border-bottom: 1px solid #ebebeb;
    text-align: center;

    &:last-of-type {
      margin-top: 2rem;
      border-bottom: none;
    }

    .change-stat__heading {
      width: 100%;
      position: absolute;
      top: 1rem;
      left: 0;
      color: @brand__grey3;
    }

    .change-stat__value {
      position: absolute;
      top: 60%;
      left: 50%;
      color: @brand--primary-color;
      font-size: 5vh;
      transform: translateY(-50%) translateX(-50%);

      .change-stat__direction--up {
        position: absolute;
        top: 50%;
        right: 0;
        border-style: solid;
        border-width: 0 1.5rem 2rem 1.5rem;
        border-color: transparent transparent #75d9c0 transparent;
        transform: translateY(-50%) translateX(120%);
      }

      .change-stat__direction--down {
        position: absolute;
        top: 50%;
        right: 0;
        border-style: solid;
        border-width: 2rem 1.5rem 0 1.5rem;
        border-color: #ff7e7e transparent transparent transparent;
        transform: translateY(-50%) translateX(120%);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ChangeStat.vue?549d555e